// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image {
  position: absolute;
  right: 5%;
  bottom: 2%;
  width: 10%;
}

.space {
  margin-top: 10%;
  margin-bottom: 10%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/profile/profile.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AACF;;AAEA;EACI,eAAA;EACA,kBAAA;AACJ","sourcesContent":[".image {\r\n  position: absolute;\r\n  right: 5%;\r\n  bottom: 2%;\r\n  width: 10%;\r\n}\r\n\r\n.space {\r\n    margin-top: 10%;\r\n    margin-bottom: 10%;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
